import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=3edb6169&scoped=true&lang=pug&"
import script from "./article-card.vue?vue&type=script&lang=js&"
export * from "./article-card.vue?vue&type=script&lang=js&"
import style0 from "./article-card.vue?vue&type=style&index=0&id=3edb6169&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb6169",
  null
  
)

export default component.exports